if(!customElements.get('cart-notes')){
  class CartNotes extends HTMLElement{
    connectedCallback(){
      this.addEventListener('pointerup',e=>{
        const t=e.target.closest('#order-note-toggle')
        if(!t) return
        e.preventDefault()
        const panel=this.querySelector('#mini-cart-note')
        const notes=this.querySelector('#mini-cart__notes')
        if(!panel||!notes) return
        panel.hidden=false
        panel.classList.add('active')
        t.setAttribute('aria-expanded','true')
        setTimeout(()=>{notes.focus({preventScroll:true})},0)
      },{passive:false})
      this.addEventListener('keydown',e=>{
        const t=e.target.closest('#order-note-toggle')
        if(!t) return
        if(e.key==='Enter'||e.key===' '){
          e.preventDefault()
          const panel=this.querySelector('#mini-cart-note')
          const notes=this.querySelector('#mini-cart__notes')
          if(!panel||!notes) return
          panel.hidden=false
          panel.classList.add('active')
          t.setAttribute('aria-expanded','true')
          setTimeout(()=>{notes.focus({preventScroll:true})},0)
        }
      })
      this.addEventListener('pointerup',e=>{
        const closeBtn=e.target.closest('.order-note-toggle__content .button, .order-note-toggle__content-overlay')
        if(!closeBtn) return
        e.preventDefault()
        const panel=this.querySelector('#mini-cart-note')
        const t=this.querySelector('#order-note-toggle')
        const notes=this.querySelector('#mini-cart__notes')
        if(notes){
          fetch(`${theme.routes.cart_update_url}.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({note:notes.value})
          })
        }
        if(panel){panel.classList.remove('active');panel.hidden=true}
        if(t){t.setAttribute('aria-expanded','false')}
      },{passive:false})
      this.addEventListener('keydown',e=>{
        if(e.key!=='Escape') return
        const panel=this.querySelector('#mini-cart-note')
        const t=this.querySelector('#order-note-toggle')
        if(panel&&!panel.hidden){
          e.preventDefault()
          panel.classList.remove('active');panel.hidden=true
          if(t) t.setAttribute('aria-expanded','false')
        }
      })
      const notes=this.querySelector('#mini-cart__notes')
      if(notes){
        notes.addEventListener('change',()=>{
          fetch(`${theme.routes.cart_update_url}.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({note:notes.value})
          })
        })
      }
    }
  }
  customElements.define('cart-notes',CartNotes)
}
